import { useState } from 'react';

interface IUseVisible {
  visible: boolean;
  switchVisible: () => void;
  handleClose: () => void;
  handleOpen: () => void;
}

export function useVisible(initialState = false): IUseVisible {
  const [visible, setVisible] = useState(initialState);

  function switchVisible() {
    setVisible((visible) => !visible);
  }

  function handleClose() {
    setVisible(false);
  }

  function handleOpen() {
    setVisible(true);
  }

  return { visible, switchVisible, handleClose, handleOpen };
}
